import { ContentResponse } from '@/features/content/types/shared';
import apiClient from '@/lib/apiClient';

const sidfotQueryKey = (sidfotGuid: string | null) => ['sidfot', sidfotGuid];
const fetchSidfot: (sidfotGuid: string | null) => Promise<ContentResponse> = async (sidfotGuid) => {
  if (sidfotGuid === null)
    return Promise.resolve(null);

  const contentResponse = await apiClient.fetch(location.href, `/api/contentbyguid/${sidfotGuid}`);

  return contentResponse.json();
};

export const sidfotQueryOptions = (sidfotGuid: string | null) => ({
  queryKey: sidfotQueryKey(sidfotGuid),
  queryFn: () => fetchSidfot(sidfotGuid),
  staleTime: 1000 * 60 * 15,
  ...(sidfotGuid === null && { gcTime: 0 }),
});
